import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/performance'
import 'firebase/storage'

export async function storeIdToken(token:firebase.auth.IdTokenResult) {
  localStorage.setItem('idToken', token.token)
  localStorage.setItem('idTokenScope', token.claims.permissions)
  localStorage.setItem('idTokenCreated', Date.parse(token.authTime).toString())
  localStorage.setItem('idTokenExpires', Date.parse(token.expirationTime).toString())
}

export function removeIdToken() {
  localStorage.removeItem('idToken')
  localStorage.removeItem('idTokenScope')
  localStorage.removeItem('idTokenCreated')
  localStorage.removeItem('idTokenExpires')
}

export default {
  install: async (Vue:Vue.VueConstructor, options: {config:Object}) => {
    if (!firebase.apps.length) firebase.initializeApp(options.config)

    const auth = firebase.auth()
    const firestore = firebase.firestore()
    const perf = firebase.performance()
    const storage = firebase.storage()

    Vue.prototype.$auth = auth
    Vue.prototype.$db = firestore
    Vue.prototype.$perf = perf
    Vue.prototype.$storage = storage
    Vue.prototype.$user = null

    auth.onAuthStateChanged(user => {
      Vue.prototype.$user = user
    })

    auth.onIdTokenChanged(async user => {
      if (user) {
        const tokenResult = await user.getIdTokenResult()
        storeIdToken(tokenResult)
        
        const expiry = Date.parse(tokenResult.expirationTime)
        const now = Date.now()
    
        if ( expiry - now < 30*60*1000 ) {
          user.getIdTokenResult(true).then(tokenResult => {
            storeIdToken(tokenResult)
          })
        }
      } else {
        removeIdToken()
      }
    })
  }
}
